import { render } from "./ActivityDetail.vue?vue&type=template&id=3f348816"
import script from "./ActivityDetail.vue?vue&type=script&lang=js"
export * from "./ActivityDetail.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__